import request from '@/shared/api/request';

export const powerCycleDatabase = (uuid: string): Promise<void> =>
  request({
    url: `/databases/${uuid}/`,
    method: 'POST',
    data: { action: 'power_cycle' },
  });
